export default __webpack_public_path__ + "static/media/Anhor Park.4cc2a865.jpg";